<template>
  <a-card title="Empresa" bodyStyle="padding: 0px;" :bordered="false">
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="Empresa">
        {{ displayValue(company?.businessName) }}
      </a-descriptions-item>
      <a-descriptions-item label="RUT">
        {{ displayValue(company?.rut) }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script setup>
import { defineProps } from 'vue';

const displayValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

defineProps({
  company: {
    type: Object,
    default: () => ({})
  }
});
</script>
